import React from 'react';
import { Route, Switch, Redirect, Link } from "react-router-dom";
import ErrorBoundary from '../components/common/ErrorBoundary';
import GoogleTagManager from '../GoogleTagManager';
import asyncComponent from '../AsyncComponent';
import '../assets/css/login.css';
import { config } from '../env_config/react-config';

export const HeaderDesktopContainer = asyncComponent(() =>
    import('./HeaderDesktopContainer').then(module => module.default)
)

export const HomeContainer = asyncComponent(() =>
    import('./HomeContainer').then(module => module.default)
)
export const BrandsContainer = asyncComponent(() =>
    import('./BrandsContainer').then(module => module.default)
)
export const BrandLandingContainer = asyncComponent(() =>
    import('./BrandLandingContainer').then(module => module.default)
)
export const CategoriesContainer = asyncComponent(() =>
    import('./CategoriesContainer').then(module => module.default)
)
export const ProductListingContainer = asyncComponent(() =>
    import('./ProductListingContainer').then(module => module.default)
)
export const HowTosContainer = asyncComponent(() =>
    import('./HowTosContainer').then(module => module.default)
)
export const TrendsContainer = asyncComponent(() =>
    import('./TrendsContainer').then(module => module.default)
)
export const ProductDetailsContainer = asyncComponent(() =>
    import('./ProductDetailsContainer').then(module => module.default)
)
export const SearchDetailsContainer = asyncComponent(() =>
    import('./SearchDetailsContainer').then(module => module.default)
)
export const Footer = asyncComponent(() =>
    import('../components/common/Footer').then(module => module.default)
)
export const ProductsToCompareContainer = asyncComponent(() =>
    import('./ProductsToCompareContainer').then(module => module.default)
)
export const FooterContainer = asyncComponent(() =>
    import('./FooterContainer').then(module => module.default)
)
export const Error404Component = asyncComponent(() =>
    import(/* webpackChunkName: "Error404Component" */ '../components/common/Error404').then(module => module.default)
)

const reges= RegExp("^(\/("+config.countryCode+")+\/[(brands|product)]+\/(.*)$)")

export const loginFn = () => {
    const uname = document.getElementById('inputuser').value;
    const pass = document.getElementById('inputPassword').value;
    localStorage.clear();
    localStorage.setItem('uname', uname);
    localStorage.setItem('pass', pass);
    document.write('<div style="text-align:center"><h2>Entering...</h2></div>');
    window.location = window.location;
}

const Login = (props) => (
    <div id="LoginForm">
        <div className="container-fluid">
	        <div className="login-form">
		        <div className="main-div">
			        <div className="panel">
				        <h2 className="text-center mb-4">Website Login</h2>
			        </div>
                    <form id="Login">
                        <div className="form-group">
                            <label>Username</label>
                            <input type="text" className="form-control" id="inputuser" placeholder="Username" />
                        </div>
                        <div className="form-group">
                            <label>Password</label>
                            <input type="password" className="form-control" id="inputPassword" placeholder="Password" />
                        </div>
                        <button type="submit" className="btn btn-primary" onClick={loginFn}>Login</button>
                    </form>
		        </div>
	        </div>
        </div>
    </div>
)

const scrollToPosition = (elementId) => {
    const $element = $('#'+elementId);
    $element.focus();
    $('html, body').animate({
        scrollTop: $element.offset().top
    }, 1000);
}

document.addEventListener('keydown', function(e){
    if( e.keyCode === 13 ) {
        e.target.click();
    }
});

const genPath = (value) => {
    return  ("/" + config.countryCode +value) ;
}

/**
 * App components - routing for the whole application
 * @function App
 * @return {div}
 */
const App = () => (
  <React.Fragment>
        {
            /* (localStorage.getItem("uname") !== "digital_blurb" || localStorage.getItem("pass") !== "balance_1849") &&
            <Login /> */
        }
        { /* <GoogleTagManager gtmId="GTM-WRMDLVP" /> */ }
        {
            // localStorage.getItem("uname") === "digital_blurb" && localStorage.getItem("pass") === "balance_1849" &&
            <React.Fragment>
                <div className="skipnav">
                    <a onClick={() => scrollToPosition('navigation')} className="sr-only sr-only-focusable" tabIndex="0" aria-label="Skip to Navigation">Skip to Navigation</a>
                    <a onClick={() => scrollToPosition('maincontent')} className="sr-only sr-only-focusable" tabIndex="0" aria-label="Skip to main content">Skip to main content</a>
                    <a onClick={() => scrollToPosition('footer')} className="sr-only sr-only-focusable" tabIndex="0" aria-label="Skip to footer">Skip to footer</a>
                </div>
                {
                    (reges.exec(window.location.pathname) === null) &&
                    <Route component={HeaderDesktopContainer} />
                }
                {
                    !config.retailerId &&
                    <Route component={Error404Component} />
                }
                {
                    config.retailerId &&
                    <Switch>
                        <Route exact path="/" render={() => {
                            return (
                            <Redirect to='/uk/' />
                            )
                        }} />
                        <Route exact path={genPath("")} component={HomeContainer} />
                        <Route path={genPath("/home")} component={HomeContainer} />
                        <Route exact path={genPath("/brands")} component={BrandsContainer} />
                        <Route path={genPath(`/brands/:brandId`)} component={BrandLandingContainer} />
                        <Route exact path={genPath(`/categories`)} component={CategoriesContainer} />
                        <Route path={genPath(`/categories/:categoryId`)} component={ProductListingContainer} />
                        <Route path={genPath(`/howto`)} component={HowTosContainer} />
                        <Route path={genPath(`/trends`)} component={TrendsContainer} />
                        <Route path={genPath(`/product/:productId`)}
                            render={(props) => (
                            <ProductDetailsContainer key={props.match.params.productId} {...props} />)}
                        />
                        <Route path={genPath(`/searchDetail`)} render={(props) => (
                            <SearchDetailsContainer key={props.location.state.searchText} {...props} />
                        )} />
                        <Route path={genPath('/productCompare/')} component={ProductsToCompareContainer} />
                        <Route path={genPath('/privacy-policy')} component={FooterContainer} />
                        <Route path={genPath('/terms-and-conditions')} component={FooterContainer} />
                        <Route path={genPath('/cookie-policy')} component={FooterContainer} />
                        <Route component={Error404Component} />
                    </Switch>
                }
                <Route component={Footer} />
            </React.Fragment>
        }
  </React.Fragment >
);

export default App;
